export default "__VITE_ASSET__C_4wd7$q__"